module.exports = __webpack_public_path__ + "assets/img/120608.784b5018.png";